interface HeroSectionProps {
  onOpenQuote: () => void;
}

export default function HeroSection({ onOpenQuote }: HeroSectionProps) {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Massive%20open-pit%20copper%20mine%20with%20heavy%20excavators%20and%20dump%20trucks%20at%20dusk%2C%20dramatic%20dark%20sky%2C%20industrial%20mining%20operation%2C%20dust%20and%20atmosphere%2C%20cinematic%20wide%20angle%2C%20dark%20moody%20tones%20with%20warm%20equipment%20lights&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
          alt="Industrial mining operation"
          className="w-full h-full object-cover object-center"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/60 to-background-950/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center section-padding max-w-5xl mx-auto pt-24 pb-16">
        <p className="text-primary-400 text-xs md:text-sm font-semibold tracking-[0.3em] uppercase mb-6">
          Global Supply, Engineered Excellence
        </p>
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-50 leading-tight mb-6">
          When Critical Equipment
          <br />
          Needs Parts That Aren't
          <br />
          <span className="text-primary-400">Easy to Find</span>
        </h1>
        <p className="text-sm md:text-base text-foreground-300 max-w-2xl mx-auto mb-10 leading-relaxed">
          New, used, OEM, and aftermarket parts for mining, construction, marine
          and power generation equipment. We source what others cannot.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => handleScroll('#products')}
            className="group flex items-center gap-3 px-7 py-3.5 bg-primary-500 text-background-950 text-sm font-bold rounded-md hover:bg-primary-400 transition-all duration-300 whitespace-nowrap tracking-wide uppercase"
          >
            Explore Solutions
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
            </span>
          </button>
          <button
            onClick={onOpenQuote}
            className="flex items-center gap-3 px-7 py-3.5 border border-foreground-400/30 text-foreground-200 text-sm font-semibold rounded-md hover:border-primary-500 hover:text-primary-400 transition-all duration-300 whitespace-nowrap tracking-wide uppercase"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-mail-send-line"></i>
            </span>
            Request a Quote
          </button>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background-950 to-transparent"></div>
    </section>
  );
}